export const setCarouselLocation = locationId => ({
    type: 'SET_CAROUSEL_LOCATION',
    locationId
});

